import { createContext as t } from "react";
t();
//# sourceMappingURL=index.es78.js.map
